import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ButtonVariant } from '../button-types';

@Component({
  selector: 'app-profile-button',
  templateUrl: './profile-button.component.html',
  styleUrls: ['./profile-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileButtonComponent {
  @Input() variant: ButtonVariant = 'primary';
  @Output() clickEvent = new EventEmitter<void>();

  get buttonStyles(): [string, string][] {
    const key = `button-profile-${this.variant}`;
    return [
      ['size', 'button-profile'],
      ['border-radius', key],
      ['background', key],
      ['border', key],
    ];
  }

  get iconColorCss(): string {
    return `--button-profile-${this.variant}-icon-fill`;
  }

  get sizeCss(): string {
    return `button-profile-${this.variant}-size`;
  }

  onClick(): void {
    this.clickEvent.emit();
  }
}
